import React, { useState } from "react";
import { Card } from "antd";
import styles from "./card.module.css";
import { Input } from "antd";
import { IconButton } from "@mui/material";
import { Button } from "antd";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const { TextArea } = Input;

interface NoteCardProps {
  id: string;
  title: string;
  content: string;
  onDelete: (id: string) => void;
  onEdit: (id: string, title: string, content: string) => void;
}

export const NoteCard: React.FC<NoteCardProps> = ({
  id,
  title,
  content,
  onDelete,
  onEdit,
}) => {
  const [editCard, setEditCard] = useState<boolean>(false);
  const [note, setNote] = useState({
    title: title,
    content: content,
  });
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlerEditCard = () => {
    setEditCard(true);
    setAnchorEl(null);
  };

  const handlerDeleCard = () => {
    onDelete(id);
    setAnchorEl(null);
  };

  const handleSaveEdit = () => {
    onEdit(id, note.title, note.content);
    setEditCard(false);
  };

  return (
    <div className={styles.card_container}>
      <Card className={styles.card}>
        <IconButton
          sx={{
            display: "flex",
            position: "absolute",
            top: "5px",
            right: "5px",
          }}
          id="demo-positioned-button"
          aria-controls={open ? "demo-positioned-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <MoreVertIcon sx={{ fontSize: "14px" }} />
        </IconButton>
        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "8px",
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
              padding: "0",
              minWidth: "80px",
            },
          }}
        >
          <MenuItem
            onClick={handlerEditCard}
            sx={{ color: "#666666", fontWeight: 500 }}
          >
            Edit
          </MenuItem>
          <MenuItem
            onClick={handlerDeleCard}
            sx={{ color: "#666666", fontWeight: 500 }}
          >
            Xóa
          </MenuItem>
        </Menu>

        <div style={{ marginBottom: "15px" }}>
          {editCard ? (
            <TextArea
              className={styles.custom_input_title_box}
              variant="underlined"
              placeholder="Tiêu đề"
              autoSize
              value={note.title}
              readOnly={!editCard}
              onChange={e => setNote({ ...note, title: e.target.value })}
            />
          ) : (
            <div className={styles.note_title}>{note.title}</div>
          )}

          {editCard ? (
            <TextArea
              className={styles.custom_input_content_box}
              variant="underlined"
              placeholder="Tạo ghi chú..."
              autoSize
              readOnly={!editCard}
              value={note.content}
              onChange={e => setNote({ ...note, content: e.target.value })}
            />
          ) : (
            <div className={styles.note_content}>{note.content}</div>
          )}
        </div>

        {editCard && (
          <div
            style={{
              display: "flex",
              position: "absolute",
              bottom: 6,
              right: 5,
            }}
          >
            <Button
              type="text"
              style={{ fontWeight: 600 }}
              onClick={handleSaveEdit}
            >
              Xong
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
};
